import type { Picture } from '../../gql';

const findStyleOptionImage = (
    // For a style image, input should be the pictures for the first style option of that style
    // For a style option image, input should be the pictures for that style option
    styleImages: Array<Picture>,
    // Default size is regular thumbnail, but other sizes can be requested
    size: 'microthumbnail' | 'preview' | 'raw' | 'thumbnail' = 'thumbnail'
): Picture | undefined => {
    // If we find an image that has isThumbnail true, return that immediately
    if (size === 'thumbnail') {
        const imageWithIsThumbnailTrue = styleImages.find(
            (image) => image.isThumbnail
        );
        if (imageWithIsThumbnailTrue) return imageWithIsThumbnailTrue;
    }

    const frontImages = styleImages.filter((image) =>
        image.perspectiveName?.toLowerCase().includes('front')
    );

    // If we have front images, we want one of those.
    const targetImages = frontImages.length ? frontImages : styleImages;

    // If we have front images, we want one of those that matches the size
    const imageMatchingSize = targetImages.find((image) => {
        const isPreview = image.url?.includes('preview');
        const isThumbnail = image.url?.includes('thumbnail');
        const isMicroThumbnail = image.url?.includes('microthumbnail');
        if (size === 'raw') {
            return !isPreview && !isThumbnail && !isMicroThumbnail;
        } else if (size === 'microthumbnail') {
            return isMicroThumbnail;
        } else if (size === 'thumbnail') {
            return isThumbnail;
        } else {
            return isPreview;
        }
    });

    // If none of the images matched the size, return the first image of the target images
    return imageMatchingSize ?? targetImages[0];
};

export { findStyleOptionImage };
